var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { forwardRef, useMultiStyleConfig } from "@chakra-ui/react";
import { useIMask } from "react-imask";
import { Input, IconButton, SvgSpriteConsumer, ButtonVariant, } from "@pluxee-design-system/core";
import { Variant, DatePickerVariant, } from "./DatePicker.types";
const RightElement = ({ variant, resetDate, }) => (_jsx(IconButton, { "aria-label": "close", onClick: resetDate, variant: ButtonVariant.ICON, isDisabled: variant === Variant.DISABLED, icon: _jsx(SvgSpriteConsumer, { svgId: "delete24", size: 24 }), sx: {
        height: "auto",
        minWidth: "fit-content",
    } }));
export const DateInput = forwardRef((_a) => {
    var { label, placeholderInput, helpText, mandatory, datePickerVariant, variant, resetDate, onChange, value, // skiping value so that it doest not override
    format } = _a, rest = __rest(_a, ["label", "placeholderInput", "helpText", "mandatory", "datePickerVariant", "variant", "resetDate", "onChange", "value", "format"]);
    const styles = useMultiStyleConfig("DatePicker", {
        variant: datePickerVariant,
    });
    const mask = format.toLowerCase().replace(/[dyhms]/g, "0");
    const { ref: maskRef, setValue, value: maskValue, } = useIMask({
        mask,
    }, {
        onAccept: (val, _, event) => {
            if (val.length === format.length) {
                // datepicker on change is called from on imask onAccept (which calls the callback we pass to the datepicker component)
                if (onChange && event) {
                    // @ts-expect-error mismatched type between imask event and datepicker
                    onChange(event);
                }
            }
        },
    });
    useEffect(() => {
        setValue(value);
    }, [setValue, value]);
    const resetMaskAndDate = useCallback(() => {
        // reset mask and picker value
        resetDate();
        setValue("");
    }, [resetDate, setValue]);
    return (_jsx(Input, Object.assign({ defaultValue: value, ref: maskRef }, rest, { title: label, placeholder: placeholderInput, helpText: helpText, helpTextIcon: helpText ? _jsx(SvgSpriteConsumer, { svgId: "help16", size: 16 }) : null, onBlur: () => {
            // resync mask value and picker value when input is blurred not in sync
            if (maskValue !== value) {
                setValue(value);
            }
        }, mandatory: mandatory, disabled: variant === Variant.DISABLED, variant: variant === Variant.DISABLED ? undefined : variant, leftElement: datePickerVariant !== DatePickerVariant.RANGE_PICKER_RIGHT ? (_jsx(SvgSpriteConsumer, { svgId: "calendar24", size: 24 })) : undefined, rightElement: variant !== Variant.READONLY &&
            maskValue &&
            datePickerVariant !== DatePickerVariant.RANGE_PICKER
            ? RightElement({
                variant: variant,
                resetDate: resetMaskAndDate,
            })
            : null, optionalElement: variant === Variant.ERROR
            ? RightElement({
                variant: variant,
                resetDate,
            })
            : null, sx: styles.dateInput })));
});
//# sourceMappingURL=DateInput.js.map